/**
 * G4. Первое сообщение: три части (обращение, суть, подпись) по 4
 * варианта; «правильного» нет, совпадение со скрытым характером даёт
 * отношения +2…+6 (написано), подсказка одной части — при отношениях ≥ 50.
 */
import { t } from '@life/i18n';
import { FIRST_LOVE_PART_IDS, FIRST_LOVE_RELATIONS_BY_MATCH, type FirstLoveInput, type FirstLoveState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function FirstLove({ state, onInput }: MinigameScreenProps<FirstLoveInput, FirstLoveState>) {
  const [parts, setParts] = useState<(number | null)[]>(() => state.parts.map(() => null));
  const complete = parts.every((p) => p !== null);
  const [m0, m1, m2, m3] = FIRST_LOVE_RELATIONS_BY_MATCH;

  return (
    <>
      <p class="hint">{t('ui.minigame.firstLove.rules', { a: m0, b: m1, c: m2, d: m3 })}</p>
      {state.parts.map((options, p) => {
        const title = t(`ui.minigame.firstLove.part.${FIRST_LOVE_PART_IDS[p] ?? p}`);
        return (
          <div class="q" key={p} data-question={p}>
            <p class="q-text">{title}</p>
            <Choice
              label={title}
              items={options.map((key, i) => ({
                text: t(key),
                ...(state.hint && state.hint.part === p && state.hint.option === i ? { note: t('ui.minigame.hint') } : {}),
              }))}
              value={parts[p] ?? null}
              onChange={(i) => setParts(parts.map((x, k) => (k === p ? i : x)))}
            />
          </div>
        );
      })}
      <button type="button" class="btn accent block" disabled={!complete} onClick={() => onInput({ parts: parts.map((x) => x ?? 0) })}>
        {t('ui.minigame.firstLove.send')}
      </button>
    </>
  );
}
